import { render } from "./RecipeCompanions.vue?vue&type=template&id=8c916cc6&scoped=true"
import script from "./RecipeCompanions.vue?vue&type=script&lang=js"
export * from "./RecipeCompanions.vue?vue&type=script&lang=js"

import "./RecipeCompanions.vue?vue&type=style&index=0&id=8c916cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c916cc6"]])

export default __exports__